import { AiFillTag, BsQuestionCircle } from "react-icons/all";
import { HStack, Tooltip } from "@chakra-ui/react";

import { ChakraText } from "components/ChakraText";
import { Icon } from "components/Icon";
import { DetailFrame } from "components/DetailFrame";
import { useModal } from "components/Modal";

import { IAppointmentDetails } from "../../application/types/IAppointmentDetails";
import { CancellationUserAppointmentReasonModal } from "../CancellationUserAppointmentReasonModal";
import { appointmentStatusMessage } from "../appointmentStatusMessage";
import { AppointmentStatus } from "../../application/types/AppointmentStatus";

interface IProps {
  appointment: IAppointmentDetails;
}

const StatusFrame = ({ appointment }: IProps) => {
  const { isOpen, onOpen, onClose } = useModal();
  const cancelTooltipMessage = "Przyczyna anulowania";
  return (
    <>
      <CancellationUserAppointmentReasonModal
        deleteReason={appointment.cancellationReason!}
        isOpen={isOpen}
        onClose={onClose}
      />

      <DetailFrame icon={AiFillTag} tooltipLabel="Status">
        <HStack>
          <ChakraText>
            {appointmentStatusMessage[appointment.status]}
          </ChakraText>
          {appointment.status === AppointmentStatus.Canceled && (
            <Tooltip
              label={cancelTooltipMessage}
              aria-label={cancelTooltipMessage}
            >
              <Icon
                icon={BsQuestionCircle}
                w={5}
                h={5}
                _hover={{
                  cursor: "pointer",
                }}
                onClick={onOpen}
              />
            </Tooltip>
          )}
        </HStack>
      </DetailFrame>
    </>
  );
};

export { StatusFrame };
